export interface DeleteUserReason {
    id?: string
    reason: string
}

export enum DeleteUserReasons {
    OTHER = `Other`,
  }